"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerToggle = exports.BmToggle = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<div class=\"nob\"></div>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\tcontain: content;\n\t\twidth: 50px;\n\t\theight: 30px;\n\t\tbox-sizing: border-box;\n\t\tborder: 1px solid #b2b2b8;\n\t\tbackground: #f4f5f7;\n\t\tcursor: pointer;\n\t\tuser-select: none;\n\t\tborder-radius: 15px;\n\t\ttransition: border-color 0.1s, background-color 0.1s;\n\t}\n\n\t:host([hidden]) {\n\t\tdisplay: none;\n\t}\n\n\t:host:focus {\n\t\toutline: 0;\n\t\tbox-shadow: 0 0 0 3px rgba(128, 128, 128, 0.3);\n\t}\n\n\t:host([on]) {\n\t\tborder-color: #688e27;\n\t\tbackground-color: #77a22d;\n\t\ttransition-delay: 0.1s;\n\t\ttransition-duration: 0.5s;\n\t}\n\n\t:host([readonly]),\n\t:host([disabled]) {\n\t\topacity: 0.6;\n\t\tcursor: default;\n\t\tpointer-events: none;\n\t}\n\n\t.nob {\n\t\tposition: absolute;\n\t\tbox-sizing: content-box;\n\t\twidth: 28px;\n\t\theight: 28px;\n\t\tbackground: #fff;\n\t\tborder: 1px solid #b2b2b8;\n\t\ttransition: all 0.1s;\n\t\tborder-radius: 15px;\n\t\ttop: -1px;\n\t\tleft: -1px;\n\t}\n\n\t:host([on]) .nob {\n\t\tleft: 20px;\n\t\tborder-color: #688e27;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmToggle = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(BmToggle, _BlueElement);

  var _super = (0, _createSuper2.default)(BmToggle);

  function BmToggle() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmToggle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    _this.on = false;
    return _this;
  }

  (0, _createClass2.default)(BmToggle, [{
    key: "toggle",
    value: function toggle() {
      this.on = !this.on;
      this.dispatchEvent(new CustomEvent('change', {
        detail: this.on
      }));
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated(changedProperties) {
      (0, _get2.default)((0, _getPrototypeOf2.default)(BmToggle.prototype), "firstUpdated", this).call(this, changedProperties);
      var host = this.shadowRoot ? this.shadowRoot.host : this;
      host.addEventListener('click', this.toggle);
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject2());
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-toggle';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        on: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);
  return BmToggle;
}(_element.BlueElement);

exports.BmToggle = BmToggle;

var registerToggle = function registerToggle() {
  return (0, _element.register)(BmToggle);
};

exports.registerToggle = registerToggle;
